import React, {Component} from 'react'
import PropTypes from "prop-types";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import Error from "../single_components/Error";
import SvGraphics from "../../assets/SvGraphics";
import {authenticationService} from "../../services/AuthenticationService";
import {OverlayTrigger} from "react-bootstrap";
import Popover from "react-bootstrap/Popover";

class SelfMedicalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            isOtherMedicalCondition: false,
            isOtherAllergics: false,
            patient_allergics: this.props.patient_allergics,
            medicalConditions: this.props.medicalConditions,
            medicalConditionsSelected: this.props.medicalConditionsSelected,
        }
    }

    componentDidMount() {
        let {t} = this.props
        let {isOtherMedicalCondition, medicalConditionsSelected, patient_allergics, isOtherAllergics} = this.state
        for (let i = 0; i < medicalConditionsSelected.length; i++) {
            if (medicalConditionsSelected[i].value.toString() === "28") {
                isOtherMedicalCondition = true
                break;
            }
        }
        for (let i = 0; i < patient_allergics.length; i++) {
            if (patient_allergics[i].value.toString() === "6") {
                isOtherAllergics = true
                break
            }
        }

        this.setState({isOtherMedicalCondition, isOtherAllergics})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }


    handleAllergicsMultiChange(option) {
        let {t} = this.props
        let isOtherAllergics = false
        for (let i = 0; i < option.length; i++) {
            if (option[i].value === 6) {
                isOtherAllergics = true
                break
            }
        }
        if (!isOtherAllergics) {
            this.props.onValueChange("OtherAllergics", "")
        }
        this.setState({isOtherAllergics})
        this.props.onClickPatientAllergics(option)
    }

    handleMedicalMultiChange(option) {

        let {t} = this.props
        let isOtherMedicalCondition = false
        for (let i = 0; i < option.length; i++) {
            if (option[i].value === 28) {
                isOtherMedicalCondition = true
                break
            }
        }
        if (!isOtherMedicalCondition) {
            this.props.onValueChange("OtherMedicalCondition", "")
        }
        this.setState({medicalConditionsSelected: option, isOtherMedicalCondition})
        this.props.onClickMedicationConditions(option)
    }

    handleMedicalDiagnoseChange(option) {
        this.onChangeDiagnose(option, "medical_diagnoses_icd_name", "medical_diagnoses_icd_code")
    }

    handleAnotherMedicalDiagnoseChange(option) {
        this.onChangeDiagnose(option, "Another_Medical_diagnoses_icd_name", "Another_Medical_diagnoses_icd_code")
    }


    render() {
        let {t} = this.props

        let {entry, medicalConditions, isOtherMedicalCondition, isOtherAllergics} = this.state
        let allergics = this.props.allergics
        let allergicOptions = [allergics.length]
        let med_condition = [medicalConditions.length]
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')

        for (let i = 0; i < medicalConditions.length; i++) {
            if (language === "he") {
                med_condition[i] = {
                    value: medicalConditions[i].Condition_ID,
                    label: medicalConditions[i].Condition_description_he
                }
            } else {
                med_condition[i] = {
                    value: medicalConditions[i].Condition_ID,
                    label: medicalConditions[i].Condition_description
                }
            }
        }

        for (let i = 0; i < allergics.length; i++) {
            if (language === "he") {
                allergicOptions[i] = {value: allergics[i].index, label: allergics[i].Allergic_name_he}
            } else {
                allergicOptions[i] = {value: allergics[i].index, label: allergics[i].Allergic_name}
            }
        }



        return (
            <div className={'patientsFormBoxes'}>


                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsHalf-height'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.medical_condition')}</label>
                        </div>
                        <PatientSelectComponent
                            placeholder={t('patient_self_boarding.choose_medical_condition')}
                            options={med_condition}
                            selectWidth={'700px'}
                            isMulti={true}
                            value={this.state.medicalConditionsSelected}
                            onChange={this.handleMedicalMultiChange.bind(this)}
                        />
                    </div>
                    <div className={'inputSlots'} style={{display: isOtherMedicalCondition ? 'block' : 'none'}}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Enter_condition')}</label>
                        <input className={'inputBoxStyle'} name="OtherMedicalCondition"
                               defaultValue={entry.OtherMedicalCondition}
                               onChange={(event) => this.props.onValueChange("OtherMedicalCondition", event.target.value)}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsHalf-height'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.choose_allergic')}</label>
                        </div>
                        <PatientSelectComponent
                            placeholder=""
                            selectWidth={'700px'}
                            options={allergicOptions}
                            isMulti={true}
                            value={this.props.patient_allergics}
                            onChange={this.handleAllergicsMultiChange.bind(this)}
                        />
                    </div>

                    <div className={'inputSlots'} style={{display: isOtherAllergics ? 'block' : 'none'}}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Enter_allergic')}</label>
                        <input className={'inputBoxStyle'} name="isOtherAllergics" defaultValue={entry.OtherAllergics}
                               onChange={(event) => this.props.onValueChange("OtherAllergics", event.target.value)}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'} id={'drug'}>
                        <div className={'infoLabel-error-block'}>
                            <label
                                className={'infoLabel-withError'}>{t('patient_self_boarding.allergy_dye')}*</label>
                            <Error isShown={!!(this.props.errors)['allergy_dye']} errorMessage={(this.props.errors)['allergy_dye']}/>

                        </div>

                        <button tabIndex={0}
                                className={entry.allergy_dye === "Yes" ? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("allergy_dye", "Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}
                                className={entry.allergy_dye === "No" ?'inputBoxStyle-yes-no-middle-selected' :'inputBoxStyle-yes-no-middle'}
                                onClick={(event) => this.props.onYesNoValueChange("allergy_dye", "No")}>{t('patient_self_boarding.no')}</button>
                        <button tabIndex={0}
                                className={entry.allergy_dye === "Unknown" ? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("allergy_dye", "Unknown")}>{t('patient_self_boarding.Unknown')}</button>
                    </div>
                </div>

                <div className={'patientsFormRow'}>

                    <div className={'inputSlots'}>
                        <div style={{display: 'flex'}}>
                            <div className='flex-Display'>
                                <label className={'infoLabel'}>{t('patient_self_boarding.transporter')}*</label>
                                <Error isShown={!!(this.props.errors)['transporter']}
                                       errorMessage={(this.props.errors)['transporter']}/>
                            </div>
                            <OverlayTrigger
                                placement={"bottom"}
                                delay={{show: 250, hide: 250}}
                                trigger={"click"}
                                rootClose
                                overlay={
                                    <Popover id="popover-faqs">
                                        <Popover.Content>

                                            <div className={'faqs-element'}>
                                                <label
                                                    className={'faqs-element-label'}>{t('patient_self_boarding.transporterInfo')}</label>
                                            </div>
                                        </Popover.Content>
                                    </Popover>
                                }>
                                <SvGraphics svgname={'info-icon'} width={'25px'} height={'20px'}
                                            className={'faqs-element-icon'}/>
                            </OverlayTrigger>
                        </div>
                        <div className={'inputBoxStyle-yes-no-row'}>

                            <button tabIndex={0}
                                    className={entry.transporter === "Yes" ? 'inputBoxStyle-yes-no-left-selected' : 'inputBoxStyle-yes-no-left'}
                                    onClick={(event) => this.props.onYesNoValueChange("transporter", "Yes")}>{t('patient_self_boarding.yes')}</button>
                            <button tabIndex={0}
                                    className={entry.transporter === "No" ? 'inputBoxStyle-yes-no-right-selected' : 'inputBoxStyle-yes-no-right'}
                                    onClick={(event) => this.props.onYesNoValueChange("transporter", "No")}>{t('patient_self_boarding.no')}</button>
                            {entry.transporter === "Yes" && this.props.docWidth > 1000 && <label
                                className={'infoLabel-transporter'}>{t('patient_self_boarding.upload_transporter_id')}</label>}
                        </div>
                    </div>
                </div>
                {entry.transporter === "Yes" && this.props.docWidth < 1000 && <div className={'patientsFormRow'}>
                    <div className={'inputSlotsText'}>
                        <label
                            className={'infoLabel-transporterName'}>{t('patient_self_boarding.upload_transporter_id')}</label>
                    </div>
                </div>}
                {entry.transporter === "Yes" &&
                    <>
                        <div className={'patientsFormRowDouble'}>
                            <div className={'inputSlots'}>
                                <div className='flex-Display'>
                                    <label
                                        className={'infoLabel'}>{t('patient_self_boarding.transporterName')}*</label>
                                    <Error isShown={!!(this.props.errors)['transporterName']}
                                           errorMessage={(this.props.errors)['transporterName']}/>
                                </div>
                                <input className={'inputBoxStyle'} type="text" name="ID"
                                       defaultValue={entry.transporterName}
                                       onChange={(event) => this.props.onValueChange("transporterName", event.target.value)}/>

                            </div>
                            <div className={'inputSlots'}>
                                <div className='flex-Display'>
                                    <label
                                        className={'infoLabel'}>{t('patient_self_boarding.transporterID')}*</label>
                                    <Error isShown={!!(this.props.errors)['transporterID']}
                                           errorMessage={(this.props.errors)['transporterID']}/>
                                </div>
                                <input className={'inputBoxStyle'} type="text" name="ID"
                                       defaultValue={entry.transporterID}
                                       onChange={(event) => this.props.onValueChange("transporterID", event.target.value)}/>

                            </div>
                        </div>

                        <div className={'patientsFormRowDouble'}>
                            <div className={'inputSlots'}>
                                <div className='flex-Display'>
                                    <label
                                        className={'infoLabel'}>{t('patient_self_boarding.transporterName2')}</label>
                                    <Error isShown={!!(this.props.errors)['transporterName2']}
                                           errorMessage={(this.props.errors)['transporterName2']}/>
                                </div>
                                <input className={'inputBoxStyle'} type="text" name="ID"
                                       defaultValue={entry.transporterName2}
                                       onChange={(event) => this.props.onValueChange("transporterName2", event.target.value)}/>

                            </div>
                            <div className={'inputSlots'}>
                                <div className='flex-Display'>
                                    <label
                                        className={'infoLabel'}>{t('patient_self_boarding.transporterID2')}</label>
                                    <Error isShown={!!(this.props.errors)['transporterID2']}
                                           errorMessage={(this.props.errors)['transporterID2']}/>
                                </div>
                                <input className={'inputBoxStyle'} type="text" name="ID"
                                       defaultValue={entry.transporterID2}
                                       onChange={(event) => this.props.onValueChange("transporterID2", event.target.value)}/>

                            </div>
                        </div>
                    </>
                }
            </div>

        )
    }
}

SelfMedicalInfo.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default SelfMedicalInfo;
